"use strict";

Shopify.theme.jsMegaMenu = {
  init: function init($section) {
    // Add settings from schema to current object

    Shopify.theme.jsMegaMenu = $.extend(this, Shopify.theme.getSectionData($section)); // Selectors

    var parentLink = this.parent_link;
    var sectionId = this.section_id;
    var $megaMenu = $section.find('.mega-menu__' + sectionId);
    var cloneMegaMenu = function cloneMegaMenu() {
      var $clone = $megaMenu.clone();

      // Section configuration and loader scripts belong only to the original
      // Shopify section. Keeping them in desktop/mobile clones creates
      // duplicate data-section-id values and invalid section-data reads.
      $clone.find('[data-section-data], script[src]').remove();

      return $clone;
    };
    var $parentElement = $('.header__menu [data-navlink-handle="' + parentLink + '"], .sticky-header__menu [data-navlink-handle="' + parentLink + '"]');
    var $parentElementLink = $parentElement.children('.header__link'); // Remove old mega menus

    $parentElement.find('.mega-menu__section').remove(); // Mobile Selectors

    var $parentMobileElement = $("[data-mobile-menu-navlink-handle=\"".concat(parentLink, "\"]"));
    /* No submenu is present - add mega menu elements and caret */
// console.log($parentMobileElement);
    if ($parentMobileElement.find('.has-no-submenu').length) {

      
      
      // Assign class to display dropdown arrow
      $parentMobileElement.find('a.mobile-menu__item').addClass('mobile-menu-link'); // Insert close icon after menu item

      $parentMobileElement.find('a').after('<span class="close-dropdown" aria-expanded="false"></span>'); // Insert placeholder ul for megamenu

//       $parentMobileElement.find('.submenu__label').after('<ul class="mobile-submenu__list mobile-menu__submenu has-mega-menu" data-mobile-submenu-first-level-list></ul>'); // Find data attribute for toggle and assign it true
            if(typeof parentLink !== "undefined"){
//             	console.log(parentLink);
                $parentMobileElement.parent('ul.mobile-menu__list').after('<ul class="mobile-submenu__list mobile-menu__submenu has-mega-menu" data-mobile-submenu-first-level-list data-mobile-menu-navlink-handle="'+parentLink+'"></ul>'); // Find data attribute for toggle and assign it true
            }
      
// console.log(            $parentMobileElement.parent('ul.mobile-menu__list'));

      var $mobileMenuToggle = $parentMobileElement.find('[data-mobile-menu-has-toggle]');
//       console.log($parentMobileElement.parents('div.mobile-menu__content'));
      $($mobileMenuToggle).attr('data-mobile-menu-has-toggle', true); // Insert mega menu


      
      var nameOfSubNav = $megaMenu.find('div[data-parent-link]').attr('data-parent-link');
      
      var $parentList = $parentMobileElement.parents('div.mobile-menu__content').find('.has-mega-menu[data-mobile-menu-navlink-handle='+nameOfSubNav+']');
//       console.log($parentList);
//       console.log( $megaMenu.find('div[data-parent-link='+nameOfSubNav+']').parent());
      
     
      
      $megaMenu.find('div[data-parent-link='+nameOfSubNav+']').parent().clone().appendTo($parentList);
      
      
      
    } else {
      /* Submenu is present - add mega menu elements and remove current sub-menu */
      var _$parentList = $parentMobileElement.find('[data-mobile-submenu-first-level-list]');

      _$parentList.empty().addClass('has-mega-menu').removeClass('has-dropdown'); // Insert mega menu


      cloneMegaMenu().appendTo(_$parentList);
    } // Desktop


    if ($parentElement.hasClass('header__item') || $parentElement.hasClass('vertical-header__first-level')) {
      // Hide default dropdown
      $parentElement.find('.navbar-dropdown').addClass('is-invisible is-hidden'); // Add arrow to parent link to indicate dropdown

      $parentElementLink.removeClass('is-arrowless');
      cloneMegaMenu().appendTo('.vertical-header__first-level[data-navlink-handle="' + parentLink + '"], .header__item[data-navlink-handle="' + parentLink + '"]'); // Add/remove classes for proper styling and append mega menu instance

      $parentElement.addClass('has-mega-menu');
    }

    $('.mega-menu__section, .navbar-item .navbar-link').mouseenter(function () {
//       $('.collection-top-bar').animate({
//         opacity: "0"
//       }, { duration:600, queue:false });
      if ($(this).parent().find('.mega-menu__section').length) {
        $('.collection-top-bar').css({'opacity':0});
      }
      
      $('.mega-menu__section').removeClass('animated');
      $(this).parent().find('.mega-menu__section').addClass('animated');
    });
    $('.mega-menu__section, .header__menu-items').mouseleave(function (event) {
      if(!$(event.relatedTarget).hasClass('navbar-item')) {
        $(this).parent().find('.mega-menu__section').removeClass('animated');
      	
      }
    });

    $('.navbar-item .navbar-link, .header__brand, .header__search').on('mouseenter', function () {
      var elem = this;
      $('body > *').css({'filter': 'none'});
      $('.mega-menu-overlay').css({'opacity':'0'}).css({'visibility':'hidden'});
      if ($(elem).parent().hasClass('has-mega-menu')) {
        //Toggle corresponding mega menu
        setTimeout(function(){
          if($(elem).parent().find('.mega-menu__section').hasClass('is-active')){
            $('.mega-menu-overlay').css({'visibility':'visible'}).css({'opacity':'0.5'});
            $('body > *:not(.header--classic, .announcement-container, .top-bar, .mega-menu-section, .mega-menu-overlay, .popup-custom-login)').css({'transition':'filter .5s ease-in-out'}).css({'filter': 'blur(5px)'});
        
          }
        },100);
        //setTimeout(function(){
        //},200);
      }
    });
    $('.navbar-item .navbar-link, .header__brand, .header__search').on('mouseover', function (event) {
      //Close any mega menus on hover
        $('.mega-menu__section').removeClass('is-active');
        if ($(this).parent().hasClass('has-mega-menu')) {
          //Toggle corresponding mega menu
          $(this).parent().find('.mega-menu__section').addClass('is-active');
        }
    });
    $('.mega-menu__section, .header__menu-items').on('mouseleave', function (event) {
      //Hide mega menu upon leaving mega menu, logo or navbar
      if(!$(event.relatedTarget).hasClass('navbar-item')) {
        $('.mega-menu__section').removeClass('is-active');
        $('body > *').css({'filter': 'none'});
        $('.mega-menu-overlay').css({'opacity': '0'}).css({'visibility': 'hidden'});
        setTimeout(function(){
        	$('.collection-top-bar').css({'opacity':1});
        },500);
        //$('.mega-menu-overlay').css({'opacity':'0'}).css({'visibility':'hidden'});
      }
    });
    $('.mega-menu--header-classic .block__menu-item .mega-menu__linklist-link').on('mouseover', function () {
      var index = $(this).attr('data-index');
      
      $(this).closest('.mega-menu').find('.images_half:not([data-index='+ index +'])').css({opacity: 0});
      $(this).closest('.mega-menu').find('.images_half[data-index='+ index +']').css({opacity: 1});
    });
  },
  showThemeEditorState: function showThemeEditorState(id, $section) {
    $('.mega-menu__' + id + ' .mega-menu').addClass('mega-menu--force-show');
    $('.mega-menu__' + id + ' .mega-menu').prev('.header__link').addClass('is-active');
  },
  hideThemeEditorState: function hideThemeEditorState(id, $section) {
    $('.mega-menu__' + id + ' .mega-menu').removeClass('mega-menu--force-show');
    $('.mega-menu__' + id + ' .mega-menu').prev('.header__link').removeClass('is-active');
  },
  displayMenu: function displayMenu(id) {
    $('.mega-menu').removeClass('mega-menu--show');
    $('.mega-menu__' + id + ' .mega-menu').addClass('mega-menu--show');
  },
  hideMenu: function hideMenu(id) {
    $('.mega-menu__' + id + ' .mega-menu').removeClass('mega-menu--show');
  },
  unload: function unload($section) {
    var parentLink = $section.find('.mega-menu').data('parent-link');
    var navLink = $('[data-navlink-handle="' + parentLink + '"]');
    navLink.off();
    navLink.find('.mega-menu__section').remove();
    $('.mega-menu__section, .navbar, .navbar-item, .header__brand, .header__search').off();
  }
};
